import styled from 'styled-components';

export const ReturnButton = styled.div`
  background: transparent;
  border: none;
  color: white;
  font-family: 'Lato';
  font-size: 1.1rem;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  & .icon {
    background-color: ${({ theme }) => theme.primary};
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 36px;
    margin-right: 1em;
  }

  &:hover .icon {
    background-color: ${({ theme }) => theme.primarySlightFade};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 1rem;
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;

  .page-enter {
    position: absolute;
    opacity: 0;
    transform: translateX(-60%);
    left: 50%;
    width: calc(100% - 2em);
  }

  .page-enter-active {
    position: absolute;
    opacity: 1;
    transform: translateX(-50%);
    transition: all 500ms;
    left: 50%;
    width: calc(100% - 2em);
  }

  .page-exit {
    position: absolute;
    opacity: 1;
    transform: translateX(-50%);
    left: 50%;
    width: calc(100% - 2em);
  }

  .page-exit-active {
    opacity: 0;
    transform: translateX(-40%);
    transition: all 500ms;
  }
`;

export const DesktopVid = styled.div`
  .video-container {
    height: 100%;
  }

  height: 189px;
  width: 336px;

  margin: auto;

  @media only screen and (min-width: 768px) {
    height: 396px;
    width: 704px;
  }

  @media only screen and (min-width: 1160px) {
    height: 652px;
    width: 1160px;
  }
`;

export const TutorialTag = styled.div`
  background-color: ${({ theme }) => theme.qfb4Dark};
  display: flex;
  color: white;
  align-items: center;
  font-family: 'Lato';
  letter-spacing: 0.2rem;
  padding: 0.5rem;

  svg {
    padding-right: 0.5rem;
  }
`;

export const Card = styled.div`
  background: rgba(0, 0, 0, 0.95);
  flex-basis: auto;
  margin: 0.25rem;
  width: calc(100% - 0.5em);

  @media only screen and (min-width: 768px) {
    /* For desktop: */
    flex-basis: calc(50% - 0.5rem);
  }
`;

export const TutText = styled.div`
  padding: 1rem;
`;
